import React from "react";
import Layout from "../../layout/customer/Layout";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import CustomerNotification from "../../layout/customer/CustomerNotification";

const Notify = () => {
  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        <div>
          <ProjectBanner
            title="Notification"
          />
        </div>
        <CustomerNotification />
      </Layout>
    </div>
  );
};

export default Notify;
